/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { TouchableOpacity } from 'react-native';
import { useDispatch } from 'react-redux';
import { ARROW_SIZE, CHECK_SIZE } from '@/constants';
import Colors from '@global/colors';
import { showAlert } from '@/store/global';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';

const TabExpand = ({
  title,
  value,
  data,
  customerActived = true,
  hasNoTodoList = [],
  hasNoInvoice = false,
  hasNoVisibility = false,
  setActiveTab = () => {},
  isCompletedLocal = false,
  localPayload = null,
  isLocked = false,
}) => {
  const dispatch = useDispatch();
  const hasNoTask = hasNoTodoList.find((item) => item?.value == value);
  let done = false;
  let disabled = false;

  if (value == 'visibility_update') {
    const hasBackendProducts = Boolean(data?.products?.length);
    const hasLocalProducts = Boolean(localPayload?.products?.length);
    done = Boolean(
      (data?.is_completed && hasBackendProducts) ||
        (isCompletedLocal && hasLocalProducts),
    );
  } else if (data?.is_completed || isCompletedLocal) {
    done = true;
  }

  if (value == 'invoice_collection' && hasNoInvoice) {
    done = true;
  }

  if (value == 'orders') {
    if (hasNoVisibility) {
      disabled = true;
    }
    if (!customerActived) {
      done = true;
    }
  }

  if (hasNoTask) {
    disabled = true;
  }

  const handleOpenTask = () => {
    if (isLocked) {
      return;
    }
    if (disabled) {
      const isOrder = value == 'orders' && hasNoVisibility;
      dispatch(
        showAlert({
          show: true,
          isModal: true,
          title: 'Information',
          description: isOrder
            ? `Visibility Update activity is not completed.`
            : `Todo list ${hasNoTask?.label} have no todo list activity.`,
          isConfirm: false,
          testID: 'todo-tab-expand-disabled',
        }),
      );
    } else {
      setActiveTab(value);
    }
  };

  return (
    <TouchableOpacity
      testID={`todo-tab-expand-${value}`}
      onPress={() => handleOpenTask()}
      activeOpacity={done || isLocked ? 1 : 0.6}
      style={{
        width: '100%',
        paddingVertical: 16,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: Colors.white,
        borderBottomColor: Colors.grey0,
        borderBottomWidth: 1,
      }}>
      <SociollaText style={{ fontSize: 12 }}>{title}</SociollaText>
      {done ? (
        <Image
          style={CHECK_SIZE}
          width={CHECK_SIZE.width}
          height={CHECK_SIZE.height}
          svg={true}
          source={require('@assets/img/icons/check-circle-blue.svg')}
        />
      ) : (
        <Image
          style={[ARROW_SIZE, { transform: [{ rotate: '-90deg' }] }]}
          width={ARROW_SIZE.width}
          height={ARROW_SIZE.height}
          svg={true}
          source={require('@assets/img/icons/arrow-down-grey.svg')}
        />
      )}
    </TouchableOpacity>
  );
};

export default React.memo(TabExpand, (prev, next) => prev == next);
